'use client'

import { PromptMode, UsePromptFormReturn } from "@/lib/types/prompt-area-types"
import { SubModeEditorDialog } from '@/components/settings/sub-mode-editor-dialog'
import { ModeBadge } from '@/components/prompt-area/mode-badge'
import { SubMode } from "@/lib/types"

export function PromptAreaModeSelector({
    promptForm
}: {
    promptForm: UsePromptFormReturn
}) {
    // Define available modes with labels and their submodes (keep image submodes defined)
    const modeOptions: { mode: PromptMode; label: string; submodes?: SubMode[] }[] = [
        {
            mode: "text",
            label: "Text",
            submodes: promptForm.availableSubModes.filter(sm => sm.type === 'text')
        },
        {
            mode: "image",
            label: "Image",
            // Inline image submodes kept for parity in UI configuration
            submodes: [
                {
                    label: "Edit",
                    type: "image",
                    modelId: "fal-ai/imagen4/preview",
                    systemPrompt: "Edit the image",
                    description: "Edit the image"
                },
                // {
                //     label: "Inpaint",
                //     type: "image",
                //     modelId: "openrouter:openai/gpt-4o",
                //     systemPrompt: "Inpaint the image",
                //     description: "Inpaint areas of an image"
                // },
                // {
                //     label: "Outpaint",
                //     type: "image",
                //     modelId: "openrouter:openai/gpt-4o",
                //     systemPrompt: "Outpaint the image",
                //     description: "Extend the canvas"
                // }
            ]
        }
    ]

    // Merge inline image submodes with availableSubModes (add only those not already present)
    const imageInlineSubmodes = (modeOptions.find(m => m.mode === 'image')?.submodes ?? []) as SubMode[]
    const availableLabels = new Set(promptForm.availableSubModes.map(sm => sm.label))
    const displaySubModes: SubMode[] = [
        ...promptForm.availableSubModes,
        ...imageInlineSubmodes.filter(im => !availableLabels.has(im.label))
    ]

    return (
        <div className="flex items-center">
            {modeOptions.map(({ mode, label }) => (
                <ModeBadge
                    key={mode}
                    label={label}
                    isActive={promptForm.currentMode === mode}
                    onClick={() => promptForm.onModeChange(mode)}
                />
            ))}
            {displaySubModes.length > 0 && (
                // <div className="mx-1 text-muted-foreground relative pt-3 overflow-visible">
                    <span className="inline-block align-middle translate-y-0.5">|</span>
                // </div>
            )}

            <div className="flex-1 min-w-0">
                <div className="flex items-center overflow-x-auto no-scrollbar pl-1 ">
                    {displaySubModes.filter(sm => sm.type === promptForm.currentMode).map((subMode, idx) => (
                        <ModeBadge
                            key={`${subMode.label}-${subMode.modelId}-${idx}`}
                            label={subMode.label}
                            description={subMode.description}
                            isActive={promptForm.currentSubMode?.label === subMode.label}
                            showClearOnActive
                            onClick={() => promptForm.onSubModeChange(subMode)}
                            onClear={() => promptForm.clearSubMode()}
                        />
                    ))}
                    {promptForm.currentMode === 'text' && <SubModeEditorDialog
                        openOnChildClick
                        onSubmit={async (value) => {
                            await promptForm.onSubModeChange(value)
                            promptForm.onSubModeChange(value)
                        }}
                    >
                        <ModeBadge
                            label="+ Custom"
                            description="Create your own sub-mode"
                        />
                    </SubModeEditorDialog>}
                </div>
            </div>
        </div>
    )
}